import {BaseEvent} from "./BaseEvent";

export class ChangeImpersonatedUserEvent extends BaseEvent {
  public static NAME = 'changeImpersonatedUser';

  constructor() {
    super(ChangeImpersonatedUserEvent.NAME);
  }
}
